import moment from "moment";
import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { formatName } from "../../../../../common/format-name";
import { ParentPermissionEnum } from "../../../../../enums/ParentPermissionEnum";
import { PermissionActionEnum } from "../../../../../enums/PermissionActionEnum";
import { ApplicationEnum } from "../../../../../enums/ApplicationEnum";
import { AnalyticsCategory } from "../../../../../services/analytics.service";
import { PermissionManager } from "../../../../../common/utilities/permission-manager";
import { NavigationService } from "../../../../../services/navigation.service";

import EmptyTextHandler from "../../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";

export default defineComponent({
    components: {
        EmptyTextHandler
    },
    props: {
        selectedPatientDetails: {
            default: null
        }
    },
    data(vm) {
        return {
            _permissionManager: null as PermissionManager,
            _navigationService: null as NavigationService,
            moment,
            formatName
        };
    },
    created() {
        this._permissionManager = Container.instance.get(PermissionManager);
        this._navigationService = Container.instance.get(NavigationService);
    },
    computed: {
        age(): string {
            if (this.selectedPatientDetails.dob) {
                let today = new Date();
                let birthDate = new Date(this.selectedPatientDetails.dob);
                let age = today.getFullYear() - birthDate.getFullYear();
                let month = today.getMonth() - birthDate.getMonth();
                if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
                    (age--).toString();
                }
                return age.toString();
            }
            return "";
        }
    },
    methods: {
        async handlePatientNameClick() {
            const isClinician = this._permissionManager.checkPermission(
                ParentPermissionEnum.clinician,
                PermissionActionEnum.canView
            );
            let redirectResponse = await this._navigationService.navigateToPatient({
                agencyId: this.selectedPatientDetails.agencyId,
                applicationId: ApplicationEnum.HomeCare,
                isClinician: isClinician,
                patientId: this.selectedPatientDetails.id
            });
            let action = "AxxessHomeCare";
            this._navigationService.redirectOnNewTab(redirectResponse, {
                category: AnalyticsCategory.CentralCalendarNavigation,
                action
            });
        }
    }
});
